import styled from '@emotion/styled';
import LogManager from './utils/LogManager';

export default function BuildNumver(props: { buildNumber: number, version: string }) {
  const { buildNumber, version }  = props;
  const logManager = LogManager.getInstance();
  if (window.env === 'prod') {
    logManager.logForSure(
      `[version] \n build: ${buildNumber} \n version: ${version}`
    )
    return null;
  }

  const Wrapper = styled('div')(
    ({ theme }) => `
      color: red;
      position: fixed;
      bottom: 10px;
      right: 20px;
      z-index: 1301;
    `,
  );

  return <Wrapper>
    <div>build: {buildNumber}</div>
    <div>version: {version}</div>
  </Wrapper>
}
